import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctorHairLong } from '@fortawesome/pro-duotone-svg-icons';
import BreadCrumbs from './BreadCrumbs';
import FeatureNav from './FeatureNav';
import FooterSection from './FooterSection';
import HeaderComponent from './HeaderComponent';
import HealthCost from "../assets/images/health_cost.svg";
import CannabisTool from "../assets/images/cannabis_tool.svg";
import '../assets/styles/main.css';

const HealthCare = () => {
  return (
    <div className="healthcare" id="healthcare">
      <HeaderComponent/>
      <FeatureNav />
      <BreadCrumbs/>
      <main className="mt-20">
        <div className="text-center mb-4">
          <h1 className="display-5 fw-bold mb-3">Healthcare</h1>
        </div>

        <section className="jumbotron border text-light rounded my-4 mx-4 pt-3 pb-0 border shadow px-0" style={{ backgroundColor: "var(--tu-teal)"}}>
          <div className="col-12 py-2 rounded" style={{ paddingLeft: "15px"}}>
            <h2 className="text-light h3">
              <FontAwesomeIcon icon={faUserDoctorHairLong} className="me-2" />
              Healthcare
            </h2>
            <p className="lead">Use these tools to research health care claim costs </p>
          </div>

          <div className="col-12 bg-light ">
            <div className="row justify-content-center px-3">
              <div className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                  rel="noopener noreferrer" href="https://healthcost.utah.gov/" title="Health Cost Compare"
                  >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Health Cost Compare</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={HealthCost}/>
                  <div className="card-body py-0">
                    <p className="card-text text-center">Compare common healthcare procedure prices</p>
                  </div>
                </a>
              </div>

              <div className="col-auto py-3">
                <a className="card mb-4 box-shadow h-100" target="_blank" 
                  rel="noopener noreferrer" href="https://healthcost.utah.gov/cannabis.php" title="Medical Cannabis"
                  >
                  <div className="card-header text-center text-white" style={{ backgroundColor: "var(--tu-teal)"}}>Medical Cannabis</div>
                  <img className="card-img-top" alt="Thumbnail [100%x150]" src={CannabisTool}/>
                  <div className="card-body py-0">
                    <p className="card-text text-center">Compare prices for Qualified Medical Providers for Medical Cannabis Cards
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  )
}

export default HealthCare